export enum APP_ENVS {
  DEFAULT = 'DEFAULT',
  DEMO = 'DEMO',
  PROD = 'PROD',
  DEV = 'DEV',
  LOCAL = 'LOCAL',
  TEST = 'TEST',
}

export const currentAppEnvironment: APP_ENVS =
  import.meta.env.VITE_ENV || APP_ENVS.DEV;

export const getDatadogEnv = (env: APP_ENVS) => {
  switch (env) {
    case APP_ENVS.TEST:
      return 'test';
    case APP_ENVS.DEFAULT:
      return 'development';
    case APP_ENVS.DEMO:
      return 'demonstration';
    case APP_ENVS.PROD:
      return 'production';
    case APP_ENVS.DEV:
      return 'development';
    case APP_ENVS.LOCAL:
      return 'local';
    default:
      throw new Error('Invalid state');
  }
};
